import React from "react";
import { phoneFormat } from "../../app/utils/testUtils";
import Barcode from "react-barcode";
import {
  ACCESSION_TEXT,
  ATTRIBUTE_FIELD_PATIENT_ID,
  ATTRIBUTE_GROUP_NAME_NPI,
  ATTRIBUTE_GROUP_NAME_ORDERING_PHYSICIAN,
  ATTRIBUTE_GROUP_PATIENT_ID,
  ATTRIBUTE_REQUISITION_IMAGE,
  convertToMMDDYYYY,
  GEVITI_LABEL,
} from "../../app/utils/Constants";
import moment from "moment";

const HomeHealthPrintTemplate = ({
  orderData = {},
  partnerConfig = [],
  testList = [],
  mode,
  genders = [],
}) => {
  const {
    orderNumber,
    partnerOrderId,
    partnerName,
    orderingPhysician,
    createDateTime,
    createDateTimeTimezone,
    patientFirstName = "",
    patientMiddleName = "",
    patientLastName = "",
    gender = "",
    patientDob = "",
    patientPhone = "",
    patientEmail = "",
    patient_id,
    address1 = "",
    address2 = "",
    city = "",
    stateName = "",
    zip = "",
    phlebotomist = { label: "Hold For Dispatch", value: 0 },
    user = {},
    scheduledDate = "",
    scheduledStartTime = "",
    scheduledEndTime = "",
    scheduledTimeZone = "",
    npi = "",
    print = {},
  } = orderData;

  let formattedGender = gender;
  if (genders && genders.length > 0 && gender) {
    const found = genders.find((g) => g.value === gender || g.key === gender);
    if (found && found.label) {
      formattedGender = found.label;
    }
  }

  return (
    <div className="print-content-container">
      <table className="header-table">
        <tr>
          <td className="partner-bar-code">
            {mode !== "create" && partnerOrderId && print && print.enabled && (
              <Barcode value={partnerOrderId} />
            )}
          </td>
          <td style={{ width: "50%", textAlign: "right" }}>
            <p
              className="section-title"
              style={{ marginBottom: "4px", marginTop: "0px" }}
            >
              {partnerName && partnerName.label ? partnerName.label : ""} Order
              #: {partnerOrderId}
            </p>
            <p className="section-title" style={{ marginTop: "0px" }}>
              MobileApp Order #: {orderNumber}
            </p>
          </td>
        </tr>
      </table>
      {/* Outer table to hold two side-by-side inner tables */}
      <table>
        <tr>
          {/* Patient Information */}
          <td style={{ width: "50%", verticalAlign: "top" }}>
            <h2 className="section-title">Patient Information</h2>
            <table className="order-info-table">
              <tr>
                <th>Name</th>
                <td>{`${patientFirstName} ${patientLastName}` || "NA"}</td>
              </tr>
              {/* <tr>
                <th>Middle Initial/Name</th>
                <td>{patientMiddleName || "NA"}</td>
              </tr>
              <tr>
                <th>Last Name</th>
                <td>{patientLastName || "NA"}</td>
              </tr> */}
              <tr>
                <th>Biological Sex</th>
                <td>{formattedGender || "NA"}</td>
              </tr>
              <tr>
                <th>DOB</th>
                <td>
                  {patientDob ? moment(patientDob).format("MM/DD/YYYY") : "NA"}
                </td>
              </tr>
              <tr>
                <th>Phone Number</th>
                <td>{patientPhone ? phoneFormat(patientPhone) : "NA"}</td>
              </tr>
            </table>
          </td>
          {/* patient Information split */}
          <td style={{ width: "50%", verticalAlign: "top" }}>
            <h2 className="section-title invisible">Patient Information</h2>
            <table className="order-info-table">
              <tr>
                <th>Email Address</th>
                <td>{patientEmail || "NA"}</td>
              </tr>
              <tr>
                <th>Partner Member ID</th>
                <td>{patient_id || "NA"}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>
                  {address1} {address2} {city} {stateName} {zip}
                </td>
              </tr>
              {/* <tr>
                <th>Address Line 2</th>
                <td> {address2}</td>
              </tr>
              <tr>
                <th> City</th>
                <td> {city || "NA"}</td>
              </tr>
              <tr>
                <th> State</th>
                <td> {stateName || "NA"}</td>
              </tr>
              <tr>
                <th> Zip</th>
                <td>{zip || "NA"}</td>
              </tr> */}
            </table>
          </td>
        </tr>
      </table>
      <hr className="print-divider" />
      <table>
        <tr>
          {/*  Schedule Confirmation Information  */}
          <td style={{ width: "50%", verticalAlign: "top" }}>
            <h2 className="section-title"> Schedule Confirmation</h2>
            <table className="order-info-table">
              <tr>
                <th>Scheduled Phlebotomist</th>
                <td>{phlebotomist ? phlebotomist.label || "NA" : "NA"}</td>
              </tr>
              {user && user.employee_id && (
                <tr>
                  <th>Phleb Employee ID</th>
                  <td>{user.employee_id || "NA"}</td>
                </tr>
              )}
              {user && user.phone_number && (
                <tr>
                  <th>Phleb Phone Number</th>
                  <td>{phoneFormat(user.phone_number.toString()) || "NA"}</td>
                </tr>
              )}
              {user && user.reporting_manager_name && (
                <tr>
                  <th>Supervisor Name</th>
                  <td>{user.reporting_manager_name || "NA"}</td>
                </tr>
              )}
              {user && user.reporting_manager_phone_number && (
                <tr>
                  <th>Supervisor Phone Number</th>
                  <td>
                    {" "}
                    {phoneFormat(
                      user.reporting_manager_phone_number.toString(),
                    ) || "NA"}
                  </td>
                </tr>
              )}
              <tr>
                <th>Scheduled Date</th>
                <td>
                  {scheduledDate
                    ? moment(scheduledDate).format("MM/DD/YYYY")
                    : "NA"}
                </td>
              </tr>
              <tr>
                <th>Start Time</th>
                <td>
                  {scheduledStartTime && scheduledStartTime.value
                    ? `${scheduledStartTime.value}${
                        scheduledTimeZone && scheduledTimeZone.abbreviation
                          ? ` ${scheduledTimeZone.abbreviation}`
                          : ""
                      }`
                    : ""}
                </td>
              </tr>
              <tr>
                <th>End Time</th>
                <td>
                  {scheduledEndTime && scheduledEndTime.value
                    ? `${scheduledEndTime.value}${
                        scheduledTimeZone && scheduledTimeZone.abbreviation
                          ? ` ${scheduledTimeZone.abbreviation}`
                          : ""
                      }`
                    : ""}
                </td>
              </tr>
            </table>
          </td>
          {/*  Partner Information  */}
          <td style={{ width: "50%", verticalAlign: "top" }}>
            <h2 className="section-title">Partner Order Information</h2>   
            <table className="order-info-table">
              <tr>
                <th>Partner Name</th>
                <td>{partnerName ? partnerName.label || " NA" : "NA"}</td>
              </tr>
              {partnerConfig && partnerConfig.length > 0 && (
                <React.Fragment>
                  {partnerConfig.map((field, index) => {
                    const {
                      field_name = "",
                      is_searchable = false,
                      attribute_group_name,
                      search_key,
                    } = field || {};

                    const fieldValue = orderData[field_name] || "";
                    if (
                      (field_name === ATTRIBUTE_FIELD_PATIENT_ID &&
                        attribute_group_name === ATTRIBUTE_GROUP_PATIENT_ID) ||
                      attribute_group_name === ATTRIBUTE_GROUP_NAME_NPI ||
                      attribute_group_name ===
                        ATTRIBUTE_GROUP_NAME_ORDERING_PHYSICIAN
                    ) {
                      return <></>;
                    }
                    if (attribute_group_name === "ACCESSION_TEXT") {
                      return <></>;
                    }

                    if (
                      attribute_group_name === "ATTRIBUTE_REQUISITION_IMAGE"
                    ) {
                      return <></>;
                    }

                    return (
                      <tr key={index}>
                        <th htmlFor={`${field_name}-account`}>{field_name}</th>
                        <td>
                          {fieldValue && fieldValue.label
                            ? fieldValue.label
                            : "NA"}
                        </td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              )}
              {print &&
                print.enabled &&
                print.attributes &&
                print.attributes.length > 0 && (
                  <>
                    {print.attributes.map((attr, idx) => (
                      <tr key={idx}>
                        <th>{attr.key}</th>
                        <td>{attr.value || "NA"}</td>
                      </tr>
                    ))}
                  </>
                )}
              <tr>
                <th>Ordering Physician</th>
                <td>{orderingPhysician || "NA"}</td>
              </tr>
              <tr>
                <th>NPI</th>
                <td>{npi || "NA"}</td>
              </tr>
              <tr>
                <th>Order Create Date / Time</th>
                <td>
                  {createDateTime
                    ? convertToMMDDYYYY(
                        createDateTime,
                        createDateTimeTimezone,
                        "",
                      )
                    : ""}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <hr className="print-divider" />
      <table>
        <tr>
          {/* Test Information  */}
          <td style={{ width: "50%", verticalAlign: "top" }}>
            <h2 className="section-title"> Testing Information</h2>
            <table className="test-info-table">
              <thead>
                <tr>
                  <th>Test Code</th>
                  <th>Test Description</th>
                  <th>Visit Type</th>
                </tr>
              </thead>
              <tbody>
                {testList.filter(ele => !ele.deleted).slice(0, 5).map((ele, i) => {
                  const {
                    testCode = "",
                    name = "",
                    orderCollectionMethod = "",
                    test_code_has_sources = [],
                  } = ele;

                  return (
                    <tr key={i}>
                      {/* Test Code and nested sources */}
                      <td>
                        <span style={{ display: "block", paddingBottom: 5 }}>
                          {testCode ? testCode.label || "NA" : "NA"}
                        </span>
                        {test_code_has_sources &&
                          test_code_has_sources.length > 0 &&
                          test_code_has_sources.map((source, index) => (
                            <div key={index} className="test-code-source">
                              <strong>{source.source} Test Code: </strong>
                              {source.test_code || ""}
                            </div>
                          ))}
                      </td>

                      {/* Test Description */}
                      <td>{name ? name.label || "NA" : "NA"}</td>

                      {/* Visit Type */}
                      <td>
                        {orderCollectionMethod
                          ? orderCollectionMethod.label || "NA"
                          : "NA"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </td>
        </tr>
      </table>

      {/* Page 2: Remaining test codes if more than 5 */}
      {testList.filter(ele => !ele.deleted).length > 5 && (
        <div style={{ pageBreakBefore: "always", paddingTop: "150px" }}>
          <table>
            <tr>
              <td style={{ width: "50%", verticalAlign: "top" }}>
                <table className="test-info-table">
                  <thead>
                    <tr>
                      <th>Test Code</th>
                      <th>Test Description</th>
                      <th>Visit Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {testList.filter(ele => !ele.deleted).slice(5).map((ele, i) => {
                      const {
                        testCode = "",
                        name = "",
                        orderCollectionMethod = "",
                        test_code_has_sources = [],
                      } = ele;

                      return (
                        <tr key={i}>
                          {/* Test Code and nested sources */}
                          <td>
                            <span style={{ display: "block", paddingBottom: 5 }}>
                              {testCode ? testCode.label || "NA" : "NA"}
                            </span>
                            {test_code_has_sources &&
                              test_code_has_sources.length > 0 &&
                              test_code_has_sources.map((source, index) => (
                                <div key={index} className="test-code-source">
                                  <strong>{source.source} Test Code: </strong>
                                  {source.test_code || ""}
                                </div>
                              ))}
                          </td>

                          {/* Test Description */}
                          <td>{name ? name.label || "NA" : "NA"}</td>

                          {/* Visit Type */}
                          <td>
                            {orderCollectionMethod
                              ? orderCollectionMethod.label || "NA"
                              : "NA"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </div>
      )}
      <table>
        <tbody>
      <tr>
        <td style={{ width: "100%", textAlign: "left" , fontStyle: 'italic', padding: "15px 0 0"}}>
            <span
              // className="section-title"
              // style={{ marginBottom: "4px", marginTop: "12px" }}
            >
              {partnerName && partnerName.label ? partnerName.label : ""} Order #: <strong>{partnerOrderId}</strong>
            </span>
            {" "}  |{" "}
            <span>
              MobileApp Order #: <strong>{orderNumber}</strong>
            </span>
          </td>
        </tr>
        </tbody>
        </table>
    </div>
  );
};

export default HomeHealthPrintTemplate;
